import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { ViewVariant } from "@/common/ts/layout";
import { ContractDto, EntityType } from "@/core/api/generated/v1";

import GeneralHistoryPaginatedList from "../../../GeneralHistory/ListView/GeneralHistoryPaginatedList";

interface Props {
  contract: ContractDto;
}

export default function GeneralHistoryTabContent({ contract }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <GeneralHistoryPaginatedList
          defaultValues={{
            subjectEntityType: EntityType.Contract,
            subjectEntityId: contract.id,
          }}
          displayProps={{
            viewVariant: ViewVariant.Tab,
          }}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
